<ap-dynforms [fieldsets]="formConfig" [formValidators]="formValidators" (apSubmit)="onSubmitClick()">
  <div class="ap-form-right" dynforms.after>
    <button type="submit" kendoButton [disabled]="!dynForm.form.valid"
            class="k-button k-primary button-important"
            [primary]="true">{{'PwRecover_Send' | translateAsync | async}}
    </button>
  </div>
</ap-dynforms>
